import { render, staticRenderFns } from "./LicencaManageModal.vue?vue&type=template&id=baa13748&scoped=true"
import script from "./LicencaManageModal.vue?vue&type=script&lang=js"
export * from "./LicencaManageModal.vue?vue&type=script&lang=js"
import style0 from "./LicencaManageModal.vue?vue&type=style&index=0&id=baa13748&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "baa13748",
  null
  
)

export default component.exports